let resultImages = {},
    readyCallback;

function addImgs(inputImages) {
    for (let name in inputImages) {
        if (inputImages.hasOwnProperty(name)) {
            addImg(name, inputImages[name]);
        }
    }
}

function addImg(key, url) {
    if (resultImages[key]) {
        return resultImages[key];
    }

    const img = new Image();
    img.onload = function () {
        resultImages[key] = img;
        if (isReady()) {
            if (typeof readyCallback === "function") {
                readyCallback();
            }
        }
    };
    resultImages[key] = false;
    img.src = url;
}

function get(key) {
    return resultImages[key];
}

function isReady() {
    for (let k in resultImages) {
        if (resultImages.hasOwnProperty(k) && !resultImages[k]) {
            return false;
        }
    }
    return true;
}

function onReady(func) {
    readyCallback = func;
}

export default {
    add: addImgs,
    get: get,
    onReady: onReady,
    isReady: isReady
};
